
import { Vue, Component, Prop } from "vue-property-decorator";
import FormDatepicker from "@/components/form/FormDatepicker.vue";

@Component({
  components: {
    FormDatepicker,
  }
})
export default class DateFilterContainer extends Vue {
  @Prop([Date, String]) start!: any | null;
  @Prop([Date, String]) end!: any | null;

  inputDate: null | String = null;

  handleStartInput(date: any) {
    this.$emit("update:start", date);
  }

  handleEndInput(date: any) {
    this.$emit("update:end", date);
  }

}
